// extracted by mini-css-extract-plugin
export default {"pop":"Animate_pop__N-XEY","animation-pop":"Animate_animation-pop__wPohx","spin":"Animate_spin__mQoSe","animation-spin":"Animate_animation-spin__UpMQH"};